import React, {useState, useEffect} from 'react';
import CloseIcon from '@material-ui/icons/Close';

const TopBarAlert = ({...props}) =>
  {
    const [active, setActive] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {     
        setMessage(props.message); 
        setActive(true);
    }, [props.message]);

    const onCloseClick = () => {
        setMessage('');
        setActive(false)
    };
   
    return active && message ? (
      <div className="slide top-bar-alert bg-gray-500  w-screen fixed top-0 left-0 py-4 px-8 shadow-md z-50" >
        <div className="animate-ping absolute w-full h-full bg-gray-500"></div>
        <div className="relative w-full pr-12">
            <span dangerouslySetInnerHTML={{__html: message}}></span>
            <span className="absolute cursor-pointer right-0 top-0">
                <CloseIcon onClick={onCloseClick} />
            </span>
        </div>
        
      </div>
    ) : '';
  }

export default TopBarAlert;